import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { useTranslation } from 'react-i18next';

const MobileNumberField = ({ errors, setErrors, setMobileNumber, mobileNumber }) => {
  const { t } = useTranslation();
  return (
    <div className="form-group" style={{ marginTop: 12 }}>
      <label
        className="form-label text-light fw-normal"
        style={{ marginBottom: 4, fontSize: 14 }}
        htmlFor="mobileNumber">
        {t('LANDING_PAGE.MOBILE_NUMBER_LABEL')} *
      </label>
      <InputMask
        mask="+999 99 9999999"
        value={mobileNumber}
        onChange={(e) => {
          const val = e.target.value;
          const valWithoutSpecChars = val.replace(/\s/g, '').replace(/_/g, '');
          if (val === '') {
            setErrors({ ...errors, mobileNumber: { required: true } });
          } else {
            if (valWithoutSpecChars.match(/^\+971([0-9]{9})+$/))
              setErrors({ ...errors, mobileNumber: {} });
            else
              setErrors({ ...errors, mobileNumber: { required:false, correct: true } });
          }
          setMobileNumber(valWithoutSpecChars);
        }}>
        {(inputProps) => (
          <input
            {...inputProps}
            type="text"
            className="form-control bg-light"
            id="mobileNumber"
            placeholder="Example: 9715xxxxxxxx"
            style={{ borderColor: errors?.mobileNumber?.required || errors?.mobileNumber?.correct ? 'red' : 'transparent' }}
          />
        )}
      </InputMask>
      {errors?.mobileNumber?.required && (
        <span className="text-light" style={{ fontSize: 14 }}>
          {t('MESSAGES.PLZ_ENTER_MOBILE_NUM')}
        </span>
      )}
      {errors?.mobileNumber?.correct && (
        <span className="text-light" style={{ fontSize: 14 }}>
          {t('MESSAGES.PLZ_ENTER_CORRECT_MOBILE_NUMBER')}
        </span>
      )}
    </div>
  );
};

MobileNumberField.propTypes = {
  errors: PropTypes.object,
  setErrors: PropTypes.func,
  mobileNumber: PropTypes.string,
  setMobileNumber: PropTypes.func
};

export default MobileNumberField;
